import { render, staticRenderFns } from "./WFObject.vue?vue&type=template&id=481f3352&scoped=true"
import script from "./WFObject.vue?vue&type=script&lang=js"
export * from "./WFObject.vue?vue&type=script&lang=js"
import style0 from "./WFObject.vue?vue&type=style&index=0&id=481f3352&prod&scoped=true&lang=less"
import style1 from "./WFObject.vue?vue&type=style&index=1&id=481f3352&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f3352",
  null
  
)

export default component.exports